import React from 'react';

export default ({ className }) => (
  <svg className={className} viewBox='0 0 30 29.5' fill='none'>
    <g>
      <path
        fill='currentColor'
        d='M15.3,0.1c-0.2-0.1-0.4-0.1-0.6,0L0,7.1l0.6,1.3L15,1.5l14.4,6.8L30,7.1L15.3,0.1z'
      />
      <path
        fill='currentColor'
        d='M25.5,15.4l-1-4.3c0-0.1,0-0.1-0.1-0.1c-0.9-1.8-2.2-2.6-4.2-2.6H9.7c-2.1,0-3.4,0.8-4.2,2.6c0,0,0,0.1-0.1,0.1l-1,4.3
		c-1,0.4-2.3,1.5-2.3,3.9v5.8c0,0.4,0.3,0.7,0.7,0.7h1.5v2.3c0,0.8,0.6,1.4,1.4,1.4h2.4c0.8,0,1.4-0.6,1.4-1.4v-2.3h10.9v2.3
		c0,0.8,0.6,1.4,1.4,1.4h2.4c0.8,0,1.4-0.6,1.4-1.4v-2.3h1.5c0.4,0,0.7-0.3,0.7-0.7v-5.8C27.9,16.9,26.5,15.8,25.5,15.4z M6.8,11.5
		C7.3,10.4,8,9.8,9.7,9.8h10.6c1.7,0,2.4,0.7,2.9,1.7l0.9,3.8H5.9L6.8,11.5z M8.1,28.1l-2.4,0v-2.3h2.4L8.1,28.1z M24.3,28.1l-2.4,0
		v-2.3h2.4L24.3,28.1z M26.5,24.4H3.5v-5.1c0-2.1,1.3-2.5,1.6-2.6h19.8c0.3,0.1,1.6,0.5,1.6,2.6V24.4z'
      />
      <path
        fill='currentColor'
        d='M7.9,17.7c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7C10.5,18.9,9.4,17.7,7.9,17.7z M7.9,21.7
		c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.2,1.3-1.2c0.7,0,1.2,0.5,1.2,1.2C9.1,21.1,8.6,21.7,7.9,21.7z'
      />
      <path
        fill='currentColor'
        d='M22.1,17.7c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7C24.8,18.9,23.6,17.7,22.1,17.7z
		 M22.1,21.7c-0.7,0-1.2-0.6-1.2-1.3c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.3,0.6,1.3,1.2C23.4,21.1,22.8,21.7,22.1,21.7z'
      />
      <rect x='11.7' y='19.7' width='6.5' height='1.4' />
    </g>
  </svg>
);
